import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

const DisplayDistchangeMoreDetail = (props) => {
  const [state, setState] = useState({
    approverGroup: true,
    tran: true,
    userName: true,
    vendor: true,
  });

  const {
    openDisplayDistchangeMoreDetailsModal,
    setopenDisplayDistchangeMoreDetailsModal,
  } = props;

  useEffect(() => {
    if (openDisplayDistchangeMoreDetailsModal) {
      let displayDistchangeSetting = localStorage.getItem(
        "displayDistchangeSetting"
      );
      let parseSetting = JSON.parse(displayDistchangeSetting);
      if (displayDistchangeSetting) {
        setState((prev) => ({ ...prev, ...parseSetting }));
      }
    }
  }, [openDisplayDistchangeMoreDetailsModal]);

  const closeDetaisModal = () => {
    let displayDistchangeSetting = localStorage.getItem(
      "displayDistchangeSetting"
    );
    let parseSetting = JSON.parse(displayDistchangeSetting);
    if (displayDistchangeSetting) {
      setState((prev) => ({ ...prev, ...parseSetting }));
    } else {
      setState((prev) => ({
        ...prev,
        approverGroup: true,
        tran: true,
        userName: true,
        vendor: true,
      }));
    }

    setopenDisplayDistchangeMoreDetailsModal(false);
  };

  const handleMoreDetailsCheckboxes = (e) => {
    let { name, checked } = e.target;
    setState((prev) => ({ ...prev, [name]: checked }));
  };

  const onSaveDisplaySetting = () => {
    let { approverGroup, tran, userName, vendor } = state;

    let obj = {
      approverGroup,
      tran,
      userName,
      vendor,
    };
    localStorage.setItem("displayDistchangeSetting", JSON.stringify(obj));

    closeDetaisModal();
  };

  return (
    <>
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={openDisplayDistchangeMoreDetailsModal}
        onHide={openDisplayDistchangeMoreDetailsModal}
        className="forgot_email_modal modal_704 mx-auto"
      >
        <Modal.Body>
          <div className="container-fluid ">
            <div className="main_wrapper p-10">
              <div className="row d-flex h-100">
                <div className="col-12 justify-content-center align-self-center form_mx_width">
                  <div className="forgot_form_main">
                    <div className="forgot_header">
                      <div className="modal-top-header">
                        <div className="row bord-btm">
                          <div className="col-auto pl-0">
                            <h6 className="text-left def-blue">
                              Display Distchange Details
                            </h6>
                          </div>
                          <div className="col d-flex justify-content-end s-c-main">
                            <button
                              onClick={onSaveDisplaySetting}
                              type="button"
                              className="btn-save"
                            >
                              <img
                                src="images/save-check.png"
                                className="mr-2"
                                alt="display-icon"
                              />
                              Save
                            </button>
                            <button
                              onClick={() =>
                                setopenDisplayDistchangeMoreDetailsModal(false)
                              }
                              type="button"
                              className="btn-save"
                            >
                              <img
                                src="images/cancel.png"
                                className="mr-2"
                                alt="display-icon"
                              />
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="forgot_body">
                      <div className="row mt-3">
                        <div className="col-md-6">
                          <div className="row no-gutters mb-md-3">
                            <div className="col-auto pr-0">
                              <div className="form-group remember_check">
                                <input
                                  type="checkbox"
                                  id="tran"
                                  name="tran"
                                  checked={state.tran}
                                  onChange={handleMoreDetailsCheckboxes}
                                />

                                <label
                                  htmlFor="tran"
                                  className="float-left"
                                ></label>
                              </div>
                            </div>
                            <div className="col pl-0">
                              <p className="f-20 m-0">Tran</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row no-gutters mb-md-3">
                            <div className="col-auto pr-0">
                              <div className="form-group remember_check">
                                <input
                                  type="checkbox"
                                  id="userName"
                                  name="userName"
                                  checked={state.userName}
                                  onChange={handleMoreDetailsCheckboxes}
                                />
                                <label
                                  htmlFor="userName"
                                  className="float-left"
                                ></label>
                              </div>
                            </div>
                            <div className="col pl-0">
                              <p className="f-20 m-0">User Name</p>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="row no-gutters mb-md-3">
                            <div className="col-auto pr-0">
                              <div className="form-group remember_check">
                                <input
                                  type="checkbox"
                                  id="vendor"
                                  name="vendor"
                                  checked={state.vendor}
                                  onChange={handleMoreDetailsCheckboxes}
                                />
                                <label
                                  htmlFor="vendor"
                                  className="float-left"
                                ></label>
                              </div>
                            </div>
                            <div className="col pl-0">
                              <p className="f-20 m-0">Vendor</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row no-gutters mb-md-3">
                            <div className="col-auto pr-0">
                              <div className="form-group remember_check">
                                <input
                                  type="checkbox"
                                  id="approverGroup"
                                  name="approverGroup"
                                  checked={state.approverGroup}
                                  onChange={handleMoreDetailsCheckboxes}
                                />
                                <label
                                  htmlFor="approverGroup"
                                  className="float-left"
                                ></label>
                              </div>
                            </div>
                            <div className="col pl-0">
                              <p className="f-20 m-0">Approver Group</p>
                            </div>
                          </div>
                        </div>

                        {/* <div className="col-md-6">
                          <div className="row no-gutters mb-md-3">
                            <div className="col-auto pr-0">
                              <div className="form-group remember_check">
                                <input
                                  type="checkbox"
                                  id="emailSupplier"
                                  name="emailSupplier"
                                  checked={state.emailSupplier}
                                  onChange={handleMoreDetailsCheckboxes}
                                />
                                <label
                                  htmlFor="emailSupplier"
                                  className="float-left"
                                ></label>
                              </div>
                            </div>
                            <div className="col pl-0">
                              <p className="f-20 m-0">Email Supplier</p>
                            </div>
                          </div>
                        </div> */}
                        {/* <div className="col-md-6">
                          <div className="row no-gutters mb-md-3">
                            <div className="col-auto pr-0">
                              <div className="form-group remember_check">
                                <input
                                  type="checkbox"
                                  id="requestBy"
                                  name="requestBy"
                                  checked={state.requestBy}
                                  onChange={handleMoreDetailsCheckboxes}
                                />
                                <label
                                  htmlFor="requestBy"
                                  className="float-left"
                                ></label>
                              </div>
                            </div>
                            <div className="col pl-0">
                              <p className="f-20 m-0">Request By</p>
                            </div>
                          </div>
                        </div> */}

                        {/* <div className="col-md-6">
                          <div className="row no-gutters mb-md-3">
                            <div className="col-auto pr-0">
                              <div className="form-group remember_check">
                                <input
                                  type="checkbox"
                                  id="tranCheck"
                                  name="tranCheck"
                                  checked={state.tranCheck}
                                  onChange={handleMoreDetailsCheckboxes}
                                />
                                <label
                                  htmlFor="tranCheck"
                                  className="float-left"
                                ></label>
                              </div>
                            </div>
                            <div className="col pl-0">
                              <p className="f-20 m-0">tran</p>
                            </div>
                          </div>
                        </div> */}
                        {/* <div className="col-md-6">
                          <div className="row no-gutters mb-md-3">
                            <div className="col-auto pr-0">
                              <div className="form-group remember_check">
                                <input
                                  type="checkbox"
                                  id="departmentCheck"
                                  name="departmentCheck"
                                  checked={state.departmentCheck}
                                  onChange={handleMoreDetailsCheckboxes}
                                />
                                <label
                                  htmlFor="departmentCheck"
                                  className="float-left"
                                ></label>
                              </div>
                            </div>
                            <div className="col pl-0">
                              <p className="f-20 m-0">Department</p>
                            </div>
                          </div>
                        </div> */}

                        {/* <div className="col-md-6">
                          <div className="row no-gutters mb-md-3">
                            <div className="col-auto pr-0">
                              <div className="form-group remember_check">
                                <input
                                  type="checkbox"
                                  id="descriptionCheck"
                                  name="descriptionCheck"
                                  checked={state.descriptionCheck}
                                  onChange={handleMoreDetailsCheckboxes}
                                />
                                <label
                                  htmlFor="descriptionCheck"
                                  className="float-left"
                                ></label>
                              </div>
                            </div>
                            <div className="col pl-0">
                              <p className="f-20 m-0">Description</p>
                            </div>
                          </div>
                        </div> */}
                        {/* <div className="col-md-6">
                          <div className="row no-gutters mb-md-3">
                            <div className="col-auto pr-0">
                              <div className="form-group remember_check">
                                <input
                                  type="checkbox"
                                  id="specCondition"
                                  name="specCondition"
                                  checked={state.specCondition}
                                  onChange={handleMoreDetailsCheckboxes}
                                />
                                <label
                                  htmlFor="specCondition"
                                  className="float-left"
                                ></label>
                              </div>
                            </div>
                            <div className="col pl-0">
                              <p className="f-20 m-0">Special Conditions</p>
                            </div>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DisplayDistchangeMoreDetail;
